import { useLocalStorage } from '@/composables/utils/useLocalStorage'
const socials = [
    {
        name: 'google',
        icon: '/images/icons/google-negative.svg',
        href: '/login/google'
    }
]
export const useSocialAuth = () => {
    const { localSet } = useLocalStorage()

    function redirectSocial(social, data, callback = null) {
        localSet(data)

        if (callback) {
            callback()
        }

        window.location.href = social.href
    }

    return { socials, redirectSocial }
}
